import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { LogoMark } from "@/components/LogoMark";
import { LogIn, Loader2 } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      navigate("/admin", { state: { user: res.data } });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Sign-in failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid place-items-center bg-[#121316] px-6">
      <div className="w-full max-w-md rounded-2xl bg-zinc-900 border border-zinc-800 p-10">
        <div className="text-center">
          <span className="mx-auto h-12 w-12 grid place-items-center bg-[#0033A0] text-white rounded-sm">
            <LogoMark size={24} />
          </span>
          <h1 className="mt-6 font-heading text-2xl font-semibold text-white tracking-tight">WebADAC Admin</h1>
          <p className="mt-2 text-sm text-zinc-400">Sign in to view and manage inbound enquiries.</p>
        </div>

        <form onSubmit={submit} className="mt-8 space-y-4" noValidate>
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-zinc-300 mb-1.5">Email</label>
            <input
              id="email"
              type="email"
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@cbkm.au"
              className="w-full px-4 py-2.5 rounded-sm bg-zinc-800 border border-zinc-700 text-white placeholder:text-zinc-500 text-sm focus:outline-none focus:ring-2 focus:ring-[#0033A0]"
            />
          </div>
          <div>
            <label htmlFor="password" className="block text-sm font-medium text-zinc-300 mb-1.5">Password</label>
            <input
              id="password"
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full px-4 py-2.5 rounded-sm bg-zinc-800 border border-zinc-700 text-white placeholder:text-zinc-500 text-sm focus:outline-none focus:ring-2 focus:ring-[#0033A0]"
            />
          </div>

          {error && <p data-testid="admin-login-error" className="text-sm text-red-400">{error}</p>}

          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#0033A0] text-white hover:bg-[#00257A] transition-colors px-6 py-3 text-sm font-medium rounded-sm disabled:opacity-60"
          >
            {loading ? <Loader2 size={16} className="animate-spin" /> : <LogIn size={16} />}
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
